import Vue from 'vue'
import Vuex from 'vuex'
import sliderModule from '@/store/modules/slider'
import mutations from '@/store/mutations'
import server from '@/api/server'


Vue.use(Vuex)


export default new Vuex.Store({
  modules: {
    slider: sliderModule,
  },
  state: {
    wpUrl: 'https://thefinestcollective.com/wp-json/wp/v2/',
    // wpUrl: 'http://staging.thefinestcollective.com/wp-json/wp/v2/',
    venues: [],
    venue: [],
    siteOptions: {},
    levels:
        [
            {
                "id": 5,
                "count": 8,
                "description": "",
                "link": "https://thefinestcollective.com/venue-levels/field-level/",
                "name": "Field Level",
                "slug": "field-level",
                "taxonomy": "venue-levels",
                "meta": [],
                "acf": [],
                "_links": {
                    "self": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels/5"}],
                    "collection": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels"}],
                    "about": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/taxonomies/venue-levels"}],
                    "wp:post_type": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-detail?venue-levels=5"}],
                    "curies": [{"name": "wp", "href": "https://api.w.org/{rel}", "templated": true}]
                }
            },
            {
                "id": 6,
                "count": 2,
                "description": "",
                "link": "https://thefinestcollective.com/venue-levels/garden-level/",
                "name": "Garden Level",
                "slug": "garden-level",
                "taxonomy": "venue-levels",
                "meta": [],
                "acf": [],
                "_links": {
                    "self": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels/6"}],
                    "collection": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels"}],
                    "about": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/taxonomies/venue-levels"}],
                    "wp:post_type": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-detail?venue-levels=6"}],
                    "curies": [{"name": "wp", "href": "https://api.w.org/{rel}", "templated": true}]
                }
            },
            {
                "id": 4,
                "count": 3,
                "description": "",
                "link": "https://thefinestcollective.com/venue-levels/mezzanine-level/",
                "name": "Mezzanine Level",
                "slug": "mezzanine-level",
                "taxonomy": "venue-levels",
                "meta": [],
                "acf": [],
                "_links": {
                    "self": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels/4"}],
                    "collection": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels"}],
                    "about": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/taxonomies/venue-levels"}],
                    "wp:post_type": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-detail?venue-levels=4"}],
                    "curies": [{"name": "wp", "href": "https://api.w.org/{rel}", "templated": true}]
                }
            },
            {
                "id": 2,
                "count": 3,
                "description": "",
                "link": "https://thefinestcollective.com/venue-levels/parking-lots/",
                "name": "Parking Lots",
                "slug": "parking-lots",
                "taxonomy": "venue-levels",
                "meta": [],
                "acf": [],
                "_links": {
                    "self": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels/2"}],
                    "collection": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels"}],
                    "about": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/taxonomies/venue-levels"}],
                    "wp:post_type": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-detail?venue-levels=2"}],
                    "curies": [{"name": "wp", "href": "https://api.w.org/{rel}", "templated": true}]
                }
            },
            {
                "id": 3,
                "count": 5,
                "description": "",
                "link": "https://thefinestcollective.com/venue-levels/street-level/",
                "name": "Street Level",
                "slug": "street-level",
                "taxonomy": "venue-levels",
                "meta": [],
                "acf": [],
                "_links": {
                    "self": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels/3"}],
                    "collection": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels"}],
                    "about": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/taxonomies/venue-levels"}],
                    "wp:post_type": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-detail?venue-levels=3"}],
                    "curies": [{"name": "wp", "href": "https://api.w.org/{rel}", "templated": true}]
                }
            },
            {
                "id": 7,
                "count": 7,
                "description": "",
                "link": "https://thefinestcollective.com/venue-levels/terrace-level/",
                "name": "Terrace Level",
                "slug": "terrace-level",
                "taxonomy": "venue-levels",
                "meta": [],
                "acf": [],
                "_links": {
                    "self": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels/7"}],
                    "collection": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels"}],
                    "about": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/taxonomies/venue-levels"}],
                    "wp:post_type": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-detail?venue-levels=7"}],
                    "curies": [{"name": "wp", "href": "https://api.w.org/{rel}", "templated": true}]
                }
            },
            {
                "id": 8,
                "count": 3,
                "description": "",
                "link": "https://thefinestcollective.com/venue-levels/upper-deck/",
                "name": "Upper Deck",
                "slug": "upper-deck",
                "taxonomy": "venue-levels",
                "meta": [],
                "acf": [],
                "_links": {
                    "self": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels/8"}],
                    "collection": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels"}],
                    "about": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/taxonomies/venue-levels"}],
                    "wp:post_type": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-detail?venue-levels=8"}],
                    "curies": [{"name": "wp", "href": "https://api.w.org/{rel}", "templated": true}]
                }
            },
            {
                "id": 21,
                "count": 2,
                "description": "",
                "link": "https://thefinestcollective.com/venue-levels/off-site-venues/",
                "name": "Off-Site Venues",
                "slug": "off-site-venues",
                "taxonomy": "venue-levels",
                "meta": [],
                "acf": [],
                "_links": {
                    "self": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels/21"}],
                    "collection": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-levels"}],
                    "about": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/taxonomies/venue-levels"}],
                    "wp:post_type": [{"href": "https://thefinestcollective.com/wp-json/wp/v2/venue-detail?venue-levels=21"}],
                    "curies": [{"name": "wp", "href": "https://api.w.org/{rel}", "templated": true}]
                }
            }
        ],
    selectedLevel: {
      id: 0,
      data: []
    },
    images: [
      // "http://thefinestcollective.com/wp-content/uploads/2016/05/stone-brewery-garden-2.jpg",
      // "http://thefinestcollective.com/wp-content/uploads/2016/05/stone-brewery-garden-1.jpg",
      // "http://thefinestcollective.com/wp-content/uploads/2016/05/stone-brewery-garden-3.jpg",
      // "http://thefinestcollective.com/wp-content/uploads/2016/05/stone-brewery-garden-4.jpg"
    ],
    venueImages: [
      // "http://thefinestcollective.com/wp-content/uploads/2016/05/stone-brewery-garden-2.jpg",
      // "http://thefinestcollective.com/wp-content/uploads/2016/05/stone-brewery-garden-1.jpg",
      // "http://thefinestcollective.com/wp-content/uploads/2016/05/stone-brewery-garden-3.jpg",
      // "http://thefinestcollective.com/wp-content/uploads/2016/05/stone-brewery-garden-4.jpg"
    ],
    packages: [],
    packageCategories: [
      {
        "id": 10,
        "count": 3,
        "description": "",
        "link": "https://thefinestcollective.com/packages-category/fantasy-baseball-package/",
        "name": "Fantasy Baseball Package",
        "slug": "fantasy-baseball-package",
        "taxonomy": "packages-category",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
          "self": [
            {
              "href": "https://thefinestcollective.com/wp-json/wp/v2/packages-category/10"
            }
          ],
          "collection": [
            {
              "href": "https://thefinestcollective.com/wp-json/wp/v2/packages-category"
            }
          ],
          "about": [
            {
              "href": "https://thefinestcollective.com/wp-json/wp/v2/taxonomies/packages-category"
            }
          ],
          "wp:post_type": [
            {
              "href": "https://thefinestcollective.com/wp-json/wp/v2/package?packages-category=10"
            }
          ],
          "curies": [
            {
              "name": "wp",
              "href": "https://api.w.org/{rel}",
              "templated": true
            }
          ]
        }
      },
      {
        "id": 11,
        "count": 3,
        "description": "",
        "link": "https://thefinestcollective.com/packages-category/school-dances-package/",
        "name": "School Dances Package",
        "slug": "school-dances-package",
        "taxonomy": "packages-category",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
          "self": [
            {
              "href": "https://thefinestcollective.com/wp-json/wp/v2/packages-category/11"
            }
          ],
          "collection": [
            {
              "href": "https://thefinestcollective.com/wp-json/wp/v2/packages-category"
            }
          ],
          "about": [
            {
              "href": "https://thefinestcollective.com/wp-json/wp/v2/taxonomies/packages-category"
            }
          ],
          "wp:post_type": [
            {
              "href": "https://thefinestcollective.com/wp-json/wp/v2/package?packages-category=11"
            }
          ],
          "curies": [
            {
              "name": "wp",
              "href": "https://api.w.org/{rel}",
              "templated": true
            }
          ]
        }
      }
    ],
    selectedPackageCategory: {
      id: 0,
      data: []
    },
    selectedPackage: [],
    packagesImages: [
      "https://thefinestcollective.com/wp-content/uploads/2016/03/home10.jpg"
    ],
    enhancements: {},
    enhancementsImages: [
      'https://thefinestcollective.com/wp-content/uploads/2016/05/western-metal-rooftop-1.jpg'
    ],
    isLoading: true,
    isFullScreen: false,
    isMainPanelOpen: false,
    isDetailPanelOpen: false,
    rootEl: null,
  },
  mutations,
  actions: {
    getLevels(context) {
      return new Promise((resolve, reject) => {
        if(context.state.levels.length > 1) {
          resolve()
        } else {
          server.getLevels()
            .then(response => {
              context.commit('setLevels', response);
              context.commit('setLoading', false);
              resolve();
              return response;
            })
            .catch(e => {
              reject(e);
              return e;
            })
        }
      })
    },
    getVenues(context) {
      return new Promise((resolve, reject) => {
        if (context.state.venues.length > 1) {
          // Data already cached
          resolve();
        } else {
          server.getVenues()
            .then(response => {
              context.commit('setVenues', response.data);
              context.commit('setLoading', false);
              resolve();
              return response;
            })
            .catch(e => {
              reject(e);
              return e;
            })
        }
      })
        .then(() => {
          return;
        })
    },
    getSiteOptions(context) {
      return new Promise((resolve, reject) => {
        if (context.state.siteOptions.length > 0) {
          // Data already cached
          resolve();
        } else {
          server.getSiteOptions()
            .then(response => {
              context.commit('setSiteOptions', response.acf);
              context.commit('setLoading', false);
              resolve();
              return response;
            })
            .catch(e => {
              reject(e);
              return e;
            })
        }
      })
        .then(() => {
          return;
        })
    },
    getPackages(context) {
      return new Promise((resolve, reject) => {
        if (context.state.packages.length > 1) {
          // Data already cached
          resolve();
        } else {
          server.getPackages()
            .then(response => {
              // console.log(response);
              context.commit('setPackages', response.data);
              context.commit('setLoading', false);
              resolve();
              return response;
            })
            .catch(e => {
              reject(e);
              return e;
            })
        }
      })
        .then(() => {
          return;
        })
    },
    getEnhancements(context) {
      return new Promise((resolve, reject) => {
        if (context.state.enhancements.content) {
          // Data already cached
          context.commit('setLoading', false);
          resolve();
        } else {
          server.getEnhancements()
            .then(response => {
              // console.log(response);
              context.commit('setEnhancements', response.data);
              context.commit('setLoading', false);
              resolve();
              return response;
            })
            .catch(e => {
              reject(e);
              return e;
            })
        }
      })
        .then(() => {
          return;
        })
    },
    loadLevel(context, levelId) {
      // console.log(this.axios);
      context.commit('setLoading', true);
      server.getLevel(levelId)
        .then((response) => {
          this.selectedLevel.id = levelId;
          this.selectedLevel.data = response.data;
        });
      // this.isLoading = false;

    },
    getInitialImages(context) {
      return new Promise((resolve, reject) => {
        server.getInitialImages()
          .then(response => {
            const images = response.data.acf.images.map(image => {
              return image.sizes['large'];
            })
            context.commit('setImages', images);
          })
          .catch(e => {
            reject(e);
            return e;
          })
      })
        .then(() => {
          return;
        })
    }
  }
})
